"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _FHIGX2EEcjs = require('../__chunks/FHIGX2EE.cjs');


var _MPIQVHCBcjs = require('../__chunks/MPIQVHCB.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/form/form-reset.tsx
var _misc = require('@ariakit/core/utils/misc');
var TagName = "button";
var useFormReset = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useFormReset2({ store, ...props }) {
    const context = _FHIGX2EEcjs.useFormContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "FormReset must be wrapped in a Form component."
    );
    props = {
      type: "reset",
      disabled: _FH6HQ5JNcjs.useStoreState.call(void 0, store, "submitting"),
      ...props
    };
    props = _MPIQVHCBcjs.useButton.call(void 0, props);
    return props;
  }
);
var FormReset = _PTOCUU2Dcjs.forwardRef.call(void 0, function FormReset2(props) {
  const htmlProps = useFormReset(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.FormReset = FormReset; exports.useFormReset = useFormReset;
